import { SortDirection } from '@tanstack/react-table'
import {
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
} from '@mui/icons-material'
import styles from './StyledSortedIndicator.module.scss'

interface Props {
  isSorted: false | SortDirection
}

const StyledSortedIndicator: React.FC<Props> = ({ isSorted }) => {
  return (
    <div aria-hidden={!isSorted} className={!isSorted ? styles.hidden : ''}>
      {isSorted === 'desc' ? (
        <KeyboardArrowDownRounded />
      ) : (
        <KeyboardArrowUpRounded />
      )}
    </div>
  )
}

export default StyledSortedIndicator
